import React from "react";
import PropTypes from "prop-types";

/**
 * CardContainer - Base container for all card components
 * Provides consistent styling and behavior for product and event cards
 * 
 * @component
 * @example
 * <CardContainer variant="default" onClick={handleClick}>
 *   <CardHeader>...</CardHeader>
 *   <CardContent>...</CardContent>
 * </CardContainer>
 */
const CardContainer = ({
    children,
    onClick,
    onMouseEnter,
    onMouseLeave,
    className = "",
    variant = "default", // "default" | "event"
}) => {
    const variantStyles = {
        default: "bg-[#EBEBE9]",
        event: "bg-[#EBEBE9]",
        special: "bg-red-400",
    };

    return (
        <div
            className={`
        flex flex-col pb-3 text-base font-bold leading-6
        rounded-[20px] w-full max-w-[250px]
        shadow-md group cursor-pointer
        ${variantStyles[variant]}
        ${className}
      `}
            onClick={onClick}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
        >
            {children}
        </div>
    );
};

CardContainer.propTypes = {
    children: PropTypes.node.isRequired,
    onClick: PropTypes.func,
    onMouseEnter: PropTypes.func,
    onMouseLeave: PropTypes.func,
    className: PropTypes.string,
    variant: PropTypes.oneOf(["default", "event"]),
};

export default CardContainer;
